export default __webpack_public_path__ + "static/grenette-bold-pro-e9282829bc3a62070e264ba52cddccc9.woff";